import * as React from 'react';

import { ConnectionType, DataConnectionIconComponent } from './DataConnectionIcon';

const rowStyle: React.CSSProperties = {
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap',
  marginLeft: 6,
  marginBottom: 6
};

const iconStyle: React.CSSProperties = {
  verticalAlign: 'text-bottom',
  marginRight: 3
};

export interface DataConnectionRowProps {
  name: string;
  displayName: string;
  connectionType: ConnectionType;
  url?: string;
  externalServer?: string;
  isCertified?: boolean;
}

export function DataConnectionRowComponent(props: DataConnectionRowProps): React.ReactElement<DataConnectionRowProps> {
  let displayName = <span>{props.displayName}</span>;
  if (props.connectionType === 'TableauServer' && props.url) {
    displayName = <a href={props.url}>{props.displayName}</a>;
  } else if (props.connectionType === 'ExternalServer' && props.externalServer) {
    displayName = <span>{props.externalServer}</span>;
  }

  return (
    <li style={rowStyle}>
      <DataConnectionIconComponent style={iconStyle} isCertified={props.isCertified} connectionType={props.connectionType} />
      {displayName}
    </li>
  );
}
